import React, { useEffect, useState } from 'react';
import CoolfooderFirstname from './CoolfooderFirstname';
import CommitmentList from './CommitmentList';
import Button from './Button';
import { i18n } from '../App';

import { Container, Typography } from '@material-ui/core';

import { useCoolfoodContext } from './Store';
import { actions } from '../state/reducer';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative'
  },
  buttons: {
    ...theme.buttons,
    marginTop: theme.spacing(5)
  },
  intro: {},
  stepTitle: {
    ...theme.stepTitle,
    marginTop: '50px!important'
  }
}));

const FirstCommitStep = () => {
  // console.log('DRAW FIRST COMMIT STEP');
  const [globalState, globalDispatch] = useCoolfoodContext();

  const classes = useStyles();

  const [hasSelectedCommitments, setHasSelectableCommitments] = useState(false);

  useEffect(() => {
    if (!globalState.coolfooder.firstname.length) {
      globalDispatch({
        type: actions.SHOW_HELP,
        content: i18n._(
          'Veuillez saisir un prénom et cliquer sur <b>Valider</b>'
        )
      });
    }
    // globalState.selectedCommitments.length == 0
  }, [globalDispatch, globalState.coolfooder.firstname]);

  useEffect(() => {
    if (
      globalState.coolfooder.firstname.length &&
      !globalState.selectedCommitments.length
    ) {
      // Normal message if user is not already engaged
      if (
        !globalState.coolfooder.commitsAlreadyTaken ||
        (globalState.coolfooder.commitsAlreadyTaken &&
          globalState.coolfooder.commitsAlreadyTaken.length === 0)
      ) {
        globalDispatch({
          type: actions.SHOW_HELP,
          content: i18n._(
            '<b>Cochez un ou plusieurs défis sur lesquels vous souhaitez vous améliorer !</b><br><br>Cliquez sur les ? pour avoir plus d\'explications sur les défis.'
          )
        });
      } else {
        globalDispatch({
          type: actions.SHOW_HELP,
          content: i18n._(
            '<b>Cochez un ou plusieurs défis sur lesquels vous souhaitez vous améliorer !</b><br><br> Si certains engagements sont grisés, c\'est parce que vous les avez déjà pris par le passé<br><br>Cliquez sur les ? pour avoir plus d\'explications sur les défis.'
          )
        });
      }
      // Display a message if user has already taken commitments
    }
  }, [
    globalDispatch,
    globalState.coolfooder.commitsAlreadyTaken,
    globalState.coolfooder.firstname,
    globalState.selectedCommitments.length
  ]);

  useEffect(() => {
    if (
      globalState.coolfooder.firstname.length &&
      globalState.selectedCommitments.length
    ) {
      globalDispatch({
        type: actions.SHOW_HELP,
        content: i18n._(
          'Parfait ! Une fois votre sélection faite, cliquez sur <b>Suivant</b> pour commencer à vous engager.'
        )
      });
    }
  }, [
    globalDispatch,
    globalState.coolfooder.firstname,
    globalState.selectedCommitments.length
  ]);

  // Change step2 label

  useEffect(() => {
    globalState.happening.commitments.forEach(c => {
      if (!c.is_selected) {
        setHasSelectableCommitments(true);
        return;
      }
    });
  }, [globalState.happening.commitments]);

  return (
    <Container fixed className={classes.root}>
      <div className={classes.intro}>
        {i18n._(
          'Prêt-e à relever des défis ? Laura, en bas de l\'écran, vous accompagne à chaque étape ! Laissez-vous guider :)'
        )}
      </div>
      <Typography className={`ribbon ${classes.stepTitle}`}>
        {i18n._('ETAPE 1 : Indiquez votre prénom')}
      </Typography>
      <CoolfooderFirstname />
      <Typography className={`ribbon ${classes.stepTitle}`}>
        {hasSelectedCommitments ? i18n._('ETAPE 2 : Choisissez vos défis') : i18n._('ETAPE 2 : Les défis selectionnés pour vous')}
      </Typography>
      <CommitmentList
        commitments={globalState.happening.commitments}
        disabled={!globalState.coolfooder.firstname}
      />
      <div className={classes.buttons}>
        <Button
          color="primary"
          disabled={globalState.currentSlide < 1}
          className="prevButton"
          onClick={() => globalDispatch({ type: actions.PREV_SLIDE })}
        >
          {i18n._('Précédent')}
        </Button>
        <Button
          color="primary"
          disabled={
            globalState.coolfooder.firstname.length === 0 ||
            globalState.selectedCommitments.length === 0
          }
          variant="contained"
          className="nextButton"
          onClick={() => globalDispatch({ type: actions.NEXT_SLIDE })}
        >
          {i18n._('Suivant')}
        </Button>
      </div>
    </Container>
  );
};

export default FirstCommitStep;
